module.exports = __webpack_public_path__ + "static/media/tempBackground.fc7b5060.jpg";